export const APPROVED_SALES_LISTING = "APPROVED_SALES_LISTING";
